import React from 'react';
import './Pages.css';

function Disclaimer() {
  return (
    <div className="container">
      <div className="page-content">
        <h1>Disclaimer</h1>
        <p className="last-updated">Last Updated: January 2025</p>

        <div className="page-section">
          <p>
            The information and tools provided on Stickyours.com are for general use only.
          </p>
        </div>

        <div className="page-section">
          <h2>Tool Disclaimer</h2>
          <ul>
            <li>The Image to Sticker Generator is an automated tool.</li>
            <li>Results may vary depending on image quality and content.</li>
            <li>We do not guarantee perfect or error-free outputs.</li>
          </ul>
        </div>

        <div className="page-section">
          <h2>No Professional Advice</h2>
          <p>
            Stickyours.com does not provide legal, business, or professional advice. Any actions
            you take based on our tools are at your own discretion.
          </p>
        </div>

        <div className="page-section">
          <h2>External Links</h2>
          <p>
            Our website may contain links to third-party websites. We are not responsible for
            their content, privacy policies, or practices.
          </p>
        </div>

        <div className="page-section">
          <h2>Limitation of Responsibility</h2>
          <p>
            Stickyours.com shall not be held liable for any direct or indirect damages arising from:
          </p>
          <ul>
            <li>Use of our tools</li>
            <li>Generated images or stickers</li>
            <li>Website downtime or errors</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Disclaimer;
